import { StyleSheet, View } from 'react-native'
import { Text as PaperText } from 'react-native-paper'
import { ButtonLink } from '@/ui/Link'

export default function InvalidInvitationPage() {
    return (
        <View style={styles.container}>
            <View style={styles.content}>
                <PaperText variant="headlineLarge">Invalid Invitation</PaperText>
                <PaperText style={styles.description}>
                    The invitation link is invalid or has expired.
                </PaperText>
            </View>
            <ButtonLink href="/auth/sign-in" title="Go to Sign In" mode="contained" />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        padding: 16,
        gap: 16,
        maxWidth: 400,
        width: '100%',
        alignSelf: 'center',
    },
    content: {
        gap: 8,
        marginBottom: 16,
    },
    description: {
        opacity: 0.7,
    },
})
